module.exports = __webpack_public_path__ + "img/1696381150449-IMG_6180.jpeg.020a1c4e.webp";